module.exports = __webpack_public_path__ + "static/media/30-9.fdc71ec4.mp3";